import { Type } from '@angular/core';
import { DocumentFormBase } from '../components/document-viewer-consultant/forms/document-form.base';
import { FormGroup } from '@angular/forms';
//TODO RIB
//import { DocumentFormRibComponent } from '../components/document-viewer-consultant/forms/document-form-rib/document-form-rib.component';
import { DocumentConsultantType } from '@lib/models/documents/document-consultant-type';
import { DocumentFormRcpComponent } from '../components/document-viewer-consultant/forms/document-form-rcp/document-form-rcp.component';
import { DocumentFormRsacComponent } from '../components/document-viewer-consultant/forms/document-form-rsac/document-form-rsac.component';
import { DocumentFormKbisComponent } from '../components/document-viewer-consultant/forms/document-form-kbis/document-form-kbis.component';
import { DocumentFormAttVigComponent } from '../components/document-viewer-consultant/forms/document-form-att-vig/document-form-att-vig.component';
import { DocumentFormCerfa3558Component } from '../components/document-viewer-consultant/forms/document-form-cerfa-3558/document-form-cerfa-3558.component';
import { DocumentFormCerfa3666Component } from '../components/document-viewer-consultant/forms/document-form-cerfa-3666/document-form-cerfa-3666.component';
import { DocumentFormNotifAffComponent } from '../components/document-viewer-consultant/forms/document-form-notif-aff/document-form-notif-aff.component';
import { DocumentFormSyntUrssafComponent } from '../components/document-viewer-consultant/forms/document-form-synt-urssaf/document-form-synt-urssaf.component';
import { DocumentFormNotifDelaiUrssafComponent } from '../components/document-viewer-consultant/forms/document-form-notif-delai-urssaf/document-form-notif-delai-urssaf.component';

export interface DocumentTypeConfig<T extends FormGroup> {
  type: DocumentConsultantType;
  helpdeskUrl?: string;
  formComponent?: Type<DocumentFormBase<T>>;
  cannotAddNewIfDocumentAlreadyExists?: boolean;
}

export const DOCUMENT_TYPE_CONFIGS: DocumentTypeConfig<FormGroup>[] = [
  //TODO RIB
  // {
  //   type: 'rib',
  //   formComponent: DocumentFormRibComponent,
  // },
  {
    type: 'rsac',
    helpdeskUrl:
      'https://prodemial.zendesk.com/hc/fr/articles/360019717592-Devenir-Agent-Commercial',
    formComponent: DocumentFormRsacComponent,
  },
  {
    type: 'kbis_pl',
    formComponent: DocumentFormKbisComponent,
  },
  {
    type: 'kbis_soc',
    formComponent: DocumentFormKbisComponent,
  },
  {
    type: 'rcp',
    helpdeskUrl:
      'https://prodemial.zendesk.com/hc/fr/articles/360019940991-Souscrire-une-assurance-RCP',
    formComponent: DocumentFormRcpComponent,
  },
  {
    type: 'attestation_vigilance_agc',
    formComponent: DocumentFormAttVigComponent,
  },
  {
    type: 'attestation_vigilance_pl',
    formComponent: DocumentFormAttVigComponent,
  },
  {
    type: 'attestation_vigilance_soc',
    formComponent: DocumentFormAttVigComponent,
  },
  {
    type: 'cerfa_3558_agc',
    formComponent: DocumentFormCerfa3558Component,
  },
  {
    type: 'cerfa_3558_pl',
    formComponent: DocumentFormCerfa3558Component,
  },
  {
    type: 'cerfa_3558_soc',
    formComponent: DocumentFormCerfa3558Component,
  },
  {
    type: 'cerfa_3666_agc',
    formComponent: DocumentFormCerfa3666Component,
  },
  {
    type: 'cerfa_3666_pl',
    formComponent: DocumentFormCerfa3666Component,
  },
  {
    type: 'cerfa_3666_soc',
    formComponent: DocumentFormCerfa3666Component,
  },
  {
    type: 'notification_affiliation_agc',
    formComponent: DocumentFormNotifAffComponent,
  },
  {
    type: 'notification_affiliation_pl',
    formComponent: DocumentFormNotifAffComponent,
  },
  {
    type: 'notification_affiliation_soc',
    formComponent: DocumentFormNotifAffComponent,
  },
  {
    type: 'capture_synthese_compte_urssaf',
    formComponent: DocumentFormSyntUrssafComponent,
  },
  {
    type: 'notif_demande_delai_urssaf',
    formComponent: DocumentFormNotifDelaiUrssafComponent,
  },
];
